import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { getTranslation } from "../services/translations";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { categories } from "./teamData";
import "./TeamPage.css";

const deptIcons = {
  ot:       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28"><path d="M12 2a5 5 0 100 10A5 5 0 0012 2z"/><path d="M6 21v-1a6 6 0 0112 0v1"/><line x1="12" y1="12" x2="12" y2="16"/></svg>,
  medical:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>,
  clinical: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28"><path d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18"/></svg>,
  pharmacy: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28"><path d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>,
  nursing:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>,
  admin:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>,
};

const TeamPage = () => {
  const { language } = useLanguage();
  const t = k => getTranslation(language, k);

  return (
    <div className="tp-page nb-page-offset">
      <Navbar />

      <section className="tp-hero">
        <div className="tp-hero-overlay" />
        <div className="tp-hero-content">
          <div className="tp-eyebrow">{t("ourPeople")}</div>
          <h1 className="tp-hero-title">{t("teamPageTitle")}</h1>
          <p className="tp-hero-subtitle">{t("teamPageSubtitle")}</p>
          <div className="tp-hero-breadcrumb">
            <Link to="/" className="tp-breadcrumb-link">{t("home")}</Link>
            <span className="tp-breadcrumb-sep">›</span>
            <span>{t("ourTeamBreadcrumb")}</span>
          </div>
        </div>
      </section>

      {/* Department cards — click to open dept page */}
      <section className="tp-departments">
        <div className="tp-departments-inner">
          <div className="tp-section-header">
            <div className="tp-section-eyebrow">{t("healthcareTeamEyebrow")}</div>
            <h2 className="tp-section-title">{t("meetOurTeam")}</h2>
            <p className="tp-section-subtitle">{t("clickDeptHint")}</p>
          </div>

          <div className="tp-cat-grid">
            {categories.map(cat => (
              <Link
                key={cat.key}
                to={`/team/${cat.key}`}
                className="tp-cat-card"
                style={{"--cat-color": cat.color, "--cat-bg": cat.bg, "--cat-border": cat.border}}
              >
                <div className="tp-cat-icon" style={{background: cat.bg, color: cat.color}}>
                  {deptIcons[cat.key]}
                </div>
                <div className="tp-cat-body">
                  <h3 className="tp-cat-title" style={{color: cat.color}}>{t(cat.titleKey)}</h3>
                  <span className="tp-cat-count" style={{background: cat.color}}>
                    {cat.members.length} {cat.members.length === 1 ? t("memberSingular") : t("memberPlural")}
                  </span>
                  <p className="tp-cat-hint">{t("clickViewMembers")}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="tp-cta">
        <div className="tp-cta-inner">
          <h2>{t("experienceCareTitle")}</h2>
          <p>{t("experienceCareDesc")}</p>
          <a href="tel:+919996504991" className="tp-cta-btn">{t("bookAppointment")}</a>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default TeamPage;
